import {useEffect, useState} from "react";
import useSWR from "swr";
import {api, HydraData} from "../../api/apiProvider";
import {UserValue} from "./index";

type Channel = {
  name: string,
  id: string,
}

export default function useChannels(companies: UserValue[] | undefined, engineId: number | undefined) {
  const [channels, setChannels] = useState<Channel[]>([]);

  const getParamsString = () => {
    const params = new URLSearchParams();

    if (engineId) {
      params.append('engine_id', String(engineId))
    }

    if (companies && companies.length > 0) {
      for (let company of companies) {
        params.append('brief.products.company.id[]', String(company.value))
      }
    }

    return params.toString()
  };

  const {
    data: channelsData,
  } = useSWR<HydraData>(!engineId && (!companies || companies.length === 0) ? null : `/channel_filters?${getParamsString()}`, api.get, {
    revalidateOnFocus: false
  });

  useEffect(() => {
    if (channelsData && channelsData.data) {
      setChannels(channelsData.data.map((channel: string) => {
        return {
          id: channel,
          name: channel,
        }
      }))
    }
  }, [channelsData]);

  return {
    channels,
  }
}
